const MAX_LENGTH:number=32;

const IM_PATH:string="https://www.gamestolearnenglish.com/content-5/image-bank/s-140/";

export const ContentSetItem=function(props:{itemIndex:number, contentSetItemTextChange:Function, imSrc:string, txt:string, removeItemClick:Function}){
	const imSrc=IM_PATH+props.imSrc+'.png';
	return(
		<div className="teachers-contentset-item">
			<img src={imSrc} className="input here" alt="and here" width={100}/>
			<span className="teachers-contentset-item-delbit" onClick={()=>{props.removeItemClick(props.imSrc)}}>x</span>
			<input className="teachers-contentset-item-input" value={props.txt} type='text' maxLength={MAX_LENGTH} onChange={(e)=>{props.contentSetItemTextChange(props.itemIndex, e.target.value)}}></input>
		</div>
	)
};
